// extracted by css-extract-rspack-plugin
export default {"item":"item-kkoRPK","active":"active-so38uM"};